// Module
var code = "<svg viewBox=\"0 0 515.556 515.556\" xmlns=\"http://www.w3.org/2000/svg\">\r\n  <path d=\"M257.778 386.671L0 128.893h128.886l128.892 128.889 128.886-128.897 128.892.008z\"/>\r\n</svg>\r\n";
// Exports
module.exports = code;